defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Models/PlayTogetherClub',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Mithril/Scripts/Core/Model',
    'DanskeSpil/Domain/Authentification/Scripts/LoginCache',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils'
  ],
  function (m, Model, LoginCache, Utils) {

    // Model:
    var PlayTogetherClub = Model('PlayTogetherClub', function (content) {
      this.fields = {
        clubId: m.prop(content.groupId || null),
        clubName: m.prop(content.name || content.clubName || null),
        chairman: m.prop(content.chairman || null),
        clubs: m.prop(content.groups || null),
        clubPlayerCount: m.prop(content.groupPlayerCount || content.playerCount || 0),
        clubPlayCount: m.prop(content.groupPlayCount || 0),
        myActivePlaysCount: m.prop(content.myActivePlaysCount || 0),
        clubPlayers: m.prop([]),
        isOpenForRegistration: m.prop(content.isOpenForRegistration || true),
        isOpenForGameCreation: m.prop(content.isOpenForGameCreation || false),
        isOpenForNewMembers: m.prop(content.isOpenForNewMembers || true),
        linkClubId: m.prop(content.linkGroupId || null),
        inviteLink: m.prop(content.inviteLink || null),
        activePlays: m.prop(null),
        activePlaysCount: m.prop(null),
        myActivePlays: m.prop(null),
        myActiveOffers: m.prop(null),
        myOffersAndActivePlays: m.prop(null),
        theme: {
          colorTheme: m.prop(content.theme ? content.theme.colorTheme || null : null),
          background: m.prop(content.theme ? content.theme.background || null : null),
          badgeBackground: m.prop(content.theme ? content.theme.badgeBackground || null : null),
          badge: m.prop(content.theme ? content.theme.badge || null : null)
        },
        rules: {
          allowAllCreate: m.prop(content.rules ? content.rules.allowAllCreate : true),
          allowAllInvite: m.prop(content.rules ? content.rules.allowAllInvite : true),
          isOpenForRegistration: m.prop(content.rules ? content.rules.isOpenForRegistration : true),
          clubNameMaxLength: 50
        }
      };

      var getUserInformation = function () {
        var user = LoginCache.getUserObj();

        if (user && user.customerInfo) {
          user.customerInfo.isChairman = m.prop(false);
        }

        return user && user.customerInfo ? user.customerInfo : null;
      };

      this.currentUser = m.prop(getUserInformation());

      if (this.currentUser() && this.fields.chairman()) {
        this.currentUser().isChairman(this.currentUser().customerId === this.fields.chairman().playerId);
      }

      // Only add active players to the club
      if (content.groupPlayers) {
        const clubPlayers = content.groupPlayers.filter((player) => {
          return ['JOINED', 'ADDED'].indexOf(player.status) > -1;
        });

        if (this.currentUser()) {
          const currentUserId = this.currentUser().customerId;
          const chairmanId = this.fields.chairman().playerId;

          // sort the players so we have the chairman as the first player, the current user as the second and then the rest
          clubPlayers.sort((a, b) => {
            if (a.playerId === chairmanId) {
              return -1;
            }
            if (b.playerId === chairmanId) {
              return 1;
            }
            if (a.playerId === currentUserId) {
              return -1;
            }
            return 0;
          });

          this.fields.clubPlayers(clubPlayers);
        }
      }

      var filterInactivePlays = function (plays, removeStates) {
        removeStates = removeStates || ['DrawFinished', 'PayoutFinished', 'Deleted']; // Available: "Unknown", "Active", "Funding", "DrawFinished", "SalesClosed", "PayoutFinished", "Deleted"
        // If plays is not an object or array then return input without modifying
        if (typeof plays !== 'object') return plays;

        // Convert single object to array of objects
        if (!Array.isArray(plays)) {
          plays = [plays];
        }

        return plays.filter(function (play) {
          return removeStates.indexOf(play.state) === -1;
        });
      };

      var filterMyActivePlays = function (plays) {
        if (!Array.isArray(plays)) return plays;

        var myActivePlays = [];
        var myOfferedPlays = [];

        plays.forEach(function (play) {
          play.playType = play.playType || 'Lightning';

          if (play.playerFundingSummaries) {
            var mySummary = play.playerFundingSummaries.filter(function (player) {
              return player.playerId === this.currentUser().customerId;
            }.bind(this)).map(function (player) {
              return player;
            });

            play.myFundingDetails = play.playerFundingDetails.filter(function (player) {
              return player.playerId === this.currentUser().customerId;
            }.bind(this))[0];
          }

          if (mySummary?.length) {
            // Add an object with only the logged in user's summary
            // mySymmary will only have one funding for the current user
            play.mySummary = mySummary[0];
            myActivePlays.push(play);
          } else {
            // Add empty mySummary object
            play.mySummary = {
              rowCount: 0,
              rowCountPerDraw: 0,
              stakeAmount: 0,
              stakeAmountPerDraw: 0,
              stakePercentageOfGroupPlay: 0
            };

            var activePlay = filterInactivePlays(play, ['SalesClosed']);

            if (activePlay[0]) {
              myOfferedPlays.push(activePlay[0]);
            }
          }
        }.bind(this));

        return {
          myActivePlays: myActivePlays,
          myOfferedPlays: myOfferedPlays
        };
      }.bind(this);

      var sortPlaysByNewestDate = function (plays) {
        if (!Array.isArray(plays)) return plays;

        var sortedPlays = plays.sort(function (a, b) {
          const dateToSortBy = a.nextDraw ? 'nextDraw' : 'firstDraw';
          // If first draw date is the same, then sort by groupPlayId (latest created first)
          if (a[dateToSortBy] === b[dateToSortBy]) {
            return b.groupPlayId - a.groupPlayId;
          }

          return new Date(a[dateToSortBy]) - new Date(b[dateToSortBy]);
        });

        return sortedPlays;
      };

      var ISO8601FormatPlays = function (plays) {
        return plays.map(function (play) {
          play.firstDraw = Utils.parseISO8601(play.firstDraw).dateObject;
          play.fundingEndTime = Utils.parseISO8601(play.fundingEndTime).dateObject;
          play.fundingDayName = Utils.parseISO8601(play.fundingEndTime.toISOString()).dayName;

          if (play.nextDraw) {
            play.nextDraw = Utils.parseISO8601(play.nextDraw).dateObject;
          }


          return play;
        });
      };

      if (content.groupPlays && Array.isArray(content.groupPlays)) {
        var plays = filterInactivePlays(content.groupPlays, ['DrawFinished', 'PayoutFinished', 'Deleted']);
        plays = sortPlaysByNewestDate(plays);
        plays = ISO8601FormatPlays(plays);

        var filteredPlays = filterMyActivePlays(plays);

        this.fields.myActivePlays(filteredPlays.myActivePlays || null);
        this.fields.myActiveOffers(filteredPlays.myOfferedPlays || null);
        this.fields.myActivePlaysCount(filteredPlays.myActivePlays.length);
        this.fields.myOffersAndActivePlays(filteredPlays.myOfferedPlays.concat(filteredPlays.myActivePlays) || null);
        this.fields.activePlays(plays);
        this.fields.activePlaysCount(plays.length);
      }

      this.removePlay = function (id) {
        var plays = this.fields.myActiveOffers().filter(function (play) {
          return play.groupPlayId !== id;
        }.bind(this));

        this.fields.myActiveOffers(plays);
      }.bind(this);

      this.getPlayById = function (id) {
        id = parseInt(id, 10);
        var play = this.fields.activePlays().filter(function (play) {
          return play.groupPlayId === id;
        }.bind(this));
        return play.length ? play[0] : null;
      }.bind(this);

      this.getPlayBySubscriptionGroupGameId = (subscriptionGroupGameId) => {
        const play = this.fields.activePlays().find((play) => {
          return play.subscriptionGroupGameId === subscriptionGroupGameId;
        });
        return play || null;
      };

      this.getPlayerById = function (playerId) {
        var player = this.fields.clubPlayers().filter(function (player) {
          return player.playerId  === playerId;
        }.bind(this));

        return player.length ? player[0] : null;
      };

      this.removePlayerFromClubPlayers = function (playerId) {
        var players = this.fields.clubPlayers().filter(function (player) {
          return player.playerId  !== playerId;
        }.bind(this));

        this.fields.clubPlayers(players);
      };

      this.getClubNameRemainingCharactersCount = () => {
        return this.fields.rules.clubNameMaxLength - (this.fields.clubName() ? this.fields.clubName().length : 0);
      };

      this.toJSON = function () {
        return {
          // `id` is the model id and has nothing to do with the club
          id: this.id(),
          clubName: this.fields.clubName,
          theme: {
            colorTheme: this.fields.theme.colorTheme,
            background: this.fields.theme.background,
            badgeBackground: this.fields.theme.badgeBackground,
            badge: this.fields.theme.badge
          },
          rules: {
            allowAllCreate: this.fields.rules.allowAllCreate,
            allowAllInvite: this.fields.rules.allowAllInvite,
            isOpenForRegistration: this.fields.rules.isOpenForRegistration
          }
        };
      }.bind(this);
    });

    // Public functions:
    return PlayTogetherClub;

  });
